import { render } from "./Bac.vue?vue&type=template&id=5463940d&scoped=true"
import script from "./Bac.vue?vue&type=script&lang=js"
export * from "./Bac.vue?vue&type=script&lang=js"

import "./Bac.vue?vue&type=style&index=0&id=5463940d&scoped=true&lang=css"
import "./Bac.vue?vue&type=style&index=1&id=5463940d&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5463940d"]])

export default __exports__